import { render, staticRenderFns } from "./tccApply.vue?vue&type=template&id=d88ddbc6&scoped=true&"
import script from "./tccApply.vue?vue&type=script&lang=js&"
export * from "./tccApply.vue?vue&type=script&lang=js&"
import style0 from "./tccApply.vue?vue&type=style&index=0&id=d88ddbc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88ddbc6",
  null
  
)

export default component.exports